import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux';

import { tryToAcceptInvite  } from '../actions/actions.export.js';

// import LoginForm from '../components/LoginForm/LoginForm.js'
// import Button from '../components/Button/Button.js'

class AcceptInvite extends Component {

  constructor(props){
    super(props);
  }

  componentDidMount(){
    window.document.title = "Accept Invite - Pattycake";
    const { dispatch, user } = this.props;

    const invite_code = this.props.match.params.invite_code;

    if(invite_code){
      if(user.isLoggedIn){
        dispatch(tryToAcceptInvite({ invite_code: invite_code }))
      } else {
        dispatch(push('/login?after=' + window.btoa('/accept-invitation/' + invite_code)))
      }
    }
  }

  render(){

    const { patternManager } = this.props;
    
    return <div className="screen-height-container">
      <div className="dead-center dead-center-themed">
        <i className="fas fa-spinner-third fa-spin fa-3x text-secondary"/>
      </div>
    </div>
  }
}

const mapStateToProps = (state) => {
  const { user } = state;

  return {
    user
  }
}

export default connect(mapStateToProps)(AcceptInvite);



// WEBPACK FOOTER //
// ./src/routes/AcceptInvite.js